// ../data/organizationData.js
const organizationData = [
  {
    "name": "SHREE JAGANNATH SEVA MANDAL",
    "address": "59, Kurla Pipe Line, Satya Nagar, Sakinaka, Mumbai-400072",
    "contacts": [
      {
        "name": "Mr. Radhashyam Panigrahi",
        "phone": "9967623063"
      },
      {
        "name": "Mr. Benudhar Biswal",
        "phone": "9004006622/9323657047"
      }
    ]
  },
  {
    "name": "BOMBAY UTKAL SAMITI",
    "address": "Naupada Lane, L.B.S.Mag. Kurla (west), Mumbai-400070, Tel No-022-25040431/538",
    "contacts": [
      {
        "name": "UtkalJyoti Mr.Dev Mohanty",
        "phone": "9323657047"
      },
      {
        "name": "Mr. Prabhakar Raulo",
        "phone": "9920463896"
      }
    ]
  },
  {
    "name": "MUMBAI ORIYA WOMEN'S ASSOCIATION \"UTKRRSHA\"",
    "address": "Bulding, Sector-12, Plot No-134, Kharghar, Navi Mumbai-410210 Tel No-022-22525007/27722297",
    "contacts": [
      {
        "name": "Dr.(Mrs.)Kananika Tripathy",
        "phone": "9821028835"
      }
    ]
  },
  {
    "name": "BRAJ GOURI TRUST",
    "address": "411, Sai Chamber, Near Railway Staton, Santacruz (East), Mumbai-40055, Tel No-022-26125301/191",
    "contacts": [
      {
        "name": "Mr.Dev Mohanty",
        "phone": "9323657047"
      },
      {
        "name": "Mr. Benudhar Biswal",
        "phone": "9004006622/9323657047"
      }
    ]
  },
  {
    "name": "JAGANNATH CENTER AID FOUNDATION",
    "address": "Plot No-273, Sector-19, Budha Mehar 'C' Galli, Near Jimmy Tower, Koparkharene, Navi Mumbai-400709",
    "contacts": [
      {
        "name": "Dr.Srikrishna Pattnaik",
        "phone": "9821024447"
      },
      {
        "name": "Mrs. Kavita Mishra",
        "phone": "9920620206"
      }
    ]
  },
  {
    "name": "\"ASHRA\"",
    "address": "M/3, Sai Vihar, 1st Floor, 22 Mint Park Road, Fort, Mumbai-400001",
    "contacts": [
      {
        "name": "S.N Mohapatra",
        "phone": "9324544841"
      }
    ]
  },
  {
    "name": "SRADHA FOUNDATION",
    "address": "618, Laxmi Plazza, new Link Road Andheri (west), Mumbai-400053, Tel No-022-40003355",
    "contacts": [
      {
        "name": "Capt.K.K Choudhury"
      },
      {
        "name": "Sadhana Choudury",
        "phone": "9819836138"
      }
    ]
  },
  {
    "name": "TRAHI ACHUTA TRUST (Sree Jaganth Temple)",
    "address": "NH-8, Mumbai-Ahamedabad Highway, Sashupada, Vashi",
    "contacts": [
      {
        "phone": "08108524433/08108255433"
      }
    ]
  },
  {
    "name": "TRAHI JHUM",
    "address": "7/C Dhabalagiri, Anushakti Nagar, Mumbai-400094.Tel No-022-25582457",
    "contacts": [
      {
        "phone": "9322262055"
      }
    ]
  },
  {
    "name": "MUMBAI ORIYA GANESH PUJA COMMITTEE",
    "address": "Gayatri Sadan, 1st Floor, Mital Estate, Sakinaka, Mumbai-400059, Tel-022-65853127",
    "contacts": [
      {
        "role": "Chief Organizer",
        "name": "Mr.Arup Pattanaik, Ex Mumbai Police Commissioner"
      },
      {
        "role": "Chairman",
        "name": "Dr Srikushna Pattnaik",
        "phone": "9821024447"
      },
      {
        "name": "Manoranjana Panda"
      }
    ]
  },
  {
    "name": "UTKALIYA SEVA SANGH",
    "address": "Block 185/1763, Sector-5 Kane Nagar, C G S Colony, Antop Hill, Mumbai-400037",
    "contacts": [
      {
        "name": "G.Rushi",
        "phone": "9820086632"
      },
      {
        "name": "Laxman Gaude",
        "phone": "9820086632"
      }
    ]
  },
  {
    "name": "UTKAL JAGRUTI SEVA SANGH",
    "address": "306, Kaveri Complex, Jaganath Mandir Marg, Sakinaka, Mumbai-400072 Tel No-022-64292392/28562887",
    "contacts": [
      {
        "name": "Mr.Kishore Chandra Mohapatra",
        "phone": "9892945111"
      },
      {
        "name": "Benudhara Biswal",
        "phone": "9004006622"
      }
    ]
  },
  {
    "name": "SHREE MAHAMANTRA NAMSANKIRTAN MANDAL",
    "address": "N.C.H. Colony, Kanjur Marg (west), Mumbai-400078, Tel no-022-25944918",
    "contacts": [
      {
        "name": "Mr.Prafulla Jena",
        "phone": "9768482752"
      },
      {
        "name": "U.N.Sahu",
        "phone": "9768482752/99877105577"
      }
    ]
  },
  {
    "name": "KALINGA ORCHESTRA",
    "address": "24, NALANDA, KVS Resident Comlex, NCH Colony, Kanjurmarg (west), Mumbai-400078",
    "contacts": [
      {
        "name": "Mr. Birakishor Patra",
        "phone": "9869360663"
      }
    ]
  },
  {
    "name": "NAVIMUMBAI JAGANNATH SEVA TRUST",
    "address": "410, Hermes Attrium, 4th Floor, Plot No-67, Sector-2, CBD Belapur, NaviMumbai-400614, Tel-022-27572008/27565103",
    "contacts": [
      {
        "role": "Chairman",
        "name": "Dr. Prashant Mohanty",
        "phone": "9322223033"
      },
      {
        "name": "Bageswar Panda",
        "phone": "9967000441"
      }
    ]
  },
  {
    "name": "JAMUNI BURUTULU SEVASANGH",
    "address": "Kaveri Building, 3rd Floor, Jagannath Mandir Road, Sakinaka, Mumbai-400068",
    "contacts": [
      {
        "name": "Mr Radhesyam Panigrahi",
        "phone": "9967623063"
      },
      {
        "name": "Mr Brajkishore Panigrahi",
        "phone": "9320984325"
      }
    ]
  },
  {
    "name": "UTKAL SEVA SANGH",
    "address": "Indira Sahakari Nagar, Janta Mitra Mandal, Behind Kala Nagar, Mulund (West), Mumbai-400080",
    "contacts": [
      {
        "name": "Mr Manoj Patra",
        "phone": "9892705184"
      }
    ]
  },
  {
    "name": "JAY JAGANNATH LOKTARAN TRUST",
    "address": "D-201, Balaji Angon, Sector -3, Kharghar, Belapara goan, NaviMumbai-410210",
    "contacts": [
      {
        "name": "Mr.R.P Muduli",
        "phone": "9821895999"
      },
      {
        "name": "R.K Mohapatra",
        "phone": "9892005199"
      }
    ]
  },
  {
    "name": "TRIMURTI MITRA MANDAL",
    "address": "Indira Sahakari Nagar, Janta Mitra Mandal, Behind Kala Nagar, Mulund (West), Mumbai-400080",
    "contacts": [
      {
        "name": "Mr. Basant Mohanty",
        "phone": "9892705184"
      }
    ]
  },
  {
    "name": "RASHTRIYA ORIYA YUVAK PRATISTHAN",
    "address": "A/501, Dev Pooja, Laxmi Nagar, Ghatkopar (East), Mumbai-400075",
    "contacts": [
      {
        "role": "Chairman",
        "name": "Srikant Padhi",
        "phone": "9820083293"
      }
    ]
  },
  {
    "name": "UTKALVASI JAGANNATH SEVA MANDAL",
    "address": "Sastri Nagar, Malang Road, Kalyan (East), Thane-421306",
    "contacts": [
      {
        "name": "Mr. Gouragopal Padhi",
        "phone": "8080004329"
      },
      {
        "name": "Mr. Gopinath Sabat",
        "phone": "9220126330"
      }
    ]
  },
  {
    "name": "MUMBAI ORIYA MAHASANGH",
    "address": "49, Fancy Chamber, 5th Floor, 94 Surat Road, Masjid€, Mumbai-400086",
    "contacts": [
      {
        "name": "Dr.Bipin Bihari Mishra",
        "phone": "9322694588"
      }
    ]
  },
  {
    "name": "TRIVENI BATESWAR SEVA SAMITI",
    "address": "Dr.Ambedkar Nagar, Naupada Lane, Vidyabihar Rd, Kurla (west), Mumbai-40070",
    "contacts": [
      {
        "name": "Simanchal Pradahan",
        "phone": "9821124979"
      }
    ]
  },
  {
    "name": "SHREE JAGANNATH TRUST",
    "address": "Annat Apt., Room No-101, A Wing, Ostwal Empire, Boisar, Thane-410501",
    "contacts": [
      {
        "name": "Kaviraj Sethy",
        "phone": "9049991658"
      }
    ]
  },
  {
    "name": "SHREE JAGANATH CHARTABLE TRUST",
    "address": "Paramanu Nagar, Boisar, Dist-Thane-401501",
    "contacts": [
      {
        "name": "Sanatan Sahu",
        "phone": "9766323246/09673236042"
      }
    ]
  },
  {
    "name": "ANUSHAKTI NAGAR ORIYA ASSOCIATION",
    "address": "1/B, Kapila Bastu, Annushakti Nagar, Mumbai-400094, Tel-022-25558953",
    "contacts": [
      {
        "name": "Mr Muktikant Ray",
        "phone": "9892850938"
      }
    ]
  },
  {
    "name": "MAHARASTRA ORIYA WELFARE ASSOCIATION",
    "address": "Plot no-29/A, Sector-5, Khargar, Navi Mumbai-410210.",
    "contacts": [
      {
        "name": "Mr.Bhagwan Panda.",
        "phone": "9967000441"
      },
      {
        "name": "Balaram Patro",
        "phone": "9769330765"
      }
    ]
  },
  {
    "name": "SISHU ANANT ASHARAM (Mumbai Unit)",
    "address": "303, Priya Laxmi Apt., Plot No -G-32/33, Sector-20, CBD Belapur, Navi Mumbai-400614, Tel -022-27578466",
    "contacts": [
      {
        "name": "Debaprasad Mishara",
        "phone": "9820337121"
      }
    ]
  },
  {
    "name": "UTKAL SEVA MANDAL",
    "address": "Kajupada Pipe Line, Sakinaka, Kurla(W), Mumbai-400072",
    "contacts": [
      {
        "name": "Brajakishore Panigrahi",
        "phone": "9320984325"
      }
    ]
  },
  {
    "name": "MUMBAI NEWS CLASSIFIES",
    "address": "V.515, 1'ST Floor, Vidyabihar Nagar Society, Vidyavihar(west), Mumbai-400086.",
    "contacts": [
      {
        "phone": "9892221761/9004199644"
      }
    ]
  },
  {
    "name": "MUMBAI ORIYA SAMAJ",
    "address": "49, Fancy Chamber, 5th Floor, 94 Surat Road, Masjid€, Mumbai-400086",
    "contacts": [
      {
        "name": "Dr.Bipin Bihari Mishra",
        "phone": "022-66100105"
      }
    ]
  },
  {
    "name": "SHREE SANESWAR MANDIR",
    "address": "New Gurukul Vidyapith, Sambhaji Nagar, Manorama Nagar Road, Thane(W), Mumbai-400607",
    "contacts": [
      {
        "name": "Dibya Charan Mohanty",
        "phone": "9869102218"
      }
    ]
  },
  {
    "name": "ODISHA BHAWAN",
    "address": "Plot No-5, Sector -30A, VASHI, Navi Mumbai-400703, 022-27813372",
    "contacts": [
      {
        "name": "Sudhir Nayak",
        "phone": "9930029716"
      },
      {
        "name": "Nilakanth Mahapatra",
        "phone": "9594710085"
      }
    ]
  },
  {
    "name": "KALINGA SEVA SANGHA",
    "address": "Dr. Samantray's House, 1st Floor, VidyaVihar Road, Naupada, Kurla (W), Mumbai-400070, Tel-022-6528196",
    "contacts": [
      {
        "name": "Mr. Chitaranjan Mohanty",
        "phone": "9892480351"
      }
    ]
  },
  {
    "name": "SHREE JAGANNATH KRUPA SEVA MANDAL",
    "address": "Vikhoroli Village, Vikhroli(East), Mumbai-400079",
    "contacts": [
      {
        "name": "Krishna Panda",
        "phone": "9869008917"
      }
    ]
  },
  {
    "name": "UTKAL MITRA MANDAL",
    "address": "Hariyalli Village, Vikhroli(East), Mumbai-400079",
    "contacts": [
      {
        "role": "Sajojak",
        "name": "Mr Durga Panda",
        "phone": "09967244458"
      },
      {
        "name": "Mr Kishor Padhi",
        "phone": "o9867916450"
      }
    ]
  },
  {
    "name": "UTKAL SEVA SAMITI",
    "address": "Ramabai Colony, E.E Highway, Ghatkopar(East), Mumbai-400075",
    "contacts": [
      {
        "name": "Mr. K.C Parida",
        "phone": "9869073103"
      }
    ]
  },
  {
    "name": "MAA DURGA PUJA COMMITTEE",
    "address": "Gangaram Patil Omkar Communication, Sector-19, House No-4, Near SaiBaba Hospital, NaviMumbai-400709",
    "contacts": [
      {
        "name": "Naresh Mohapatra",
        "phone": "9323597244"
      }
    ]
  },
  {
    "name": "JAY BHAWANI MITRA MANDAL",
    "address": "Nanabai Chawl, WF-25, Near Naupada Baudi, Naupada, Kurla west, Mumbai-400070",
    "contacts": [
      {
        "name": "Mr Rabiendra Moharana",
        "phone": "9819781040"
      }
    ]
  },
  {
    "name": "NEW JAGANNATH PURI SANTH SAMAJ",
    "address": "Hariyalli Village, Vikhroli(East), Mumbai-400079",
    "contacts": [
      {
        "name": "Parameswar Dash",
        "phone": "9869334051"
      }
    ]
  },
  {
    "name": "Utakala jagruti Sevasangha",
    "address": null,
    "contacts": [
      {
        "name": "K.C.Mohapatra"
      },
      {
        "name": "Benudhara Biswala"
      },
      {
        "name": "Manoranjana Panda"
      }
    ]
  },
  {
    "name": "KALINGA SEVA SAMITI",
    "address": "Vithwa Kalwa, Thane(West), Mumbai-421306",
    "contacts": [
      {
        "name": "Rabiendra Pradhan",
        "phone": "9322397322"
      }
    ]
  },
  {
    "name": "JAGANNATH BHAJAN MANDAL",
    "address": "Navy Nagar, Colaba, Mumbai-400032",
    "contacts": [
      {
        "name": "Achutananda Khatua",
        "phone": "9833598730"
      }
    ]
  },
  {
    "name": "SYMPHONY ' MUSICAL GROUP",
    "address": "Room No-2975, Building No-214, Sector-2, Khane Nagar, AntopHill, Mumbai-400037",
    "contacts": [
      {
        "name": "Bansi Jadukar",
        "phone": "9930611698"
      },
      {
        "name": "Ratnakar Tripathy",
        "phone": "9820993289"
      }
    ]
  },
  {
    "name": "THE LEGENDS ENTERTAINMENT GROUP",
    "address": "202, Suyog Apt. Plot No-247/248, Sector-26 A, Koparipada, Vashi, NaviMumbai-400705",
    "contacts": [
      {
        "name": "Mr. Sujit Kumar Parida",
        "phone": "9892138604"
      }
    ]
  },
  {
    "name": "AMARESWAR MANDIR",
    "address": "Amar Nagar, Naupada, New Muncipalty Dawakhana, Naupada, Kurla, Mumbai-400070",
    "contacts": [
      {
        "name": "Mr. Ramesh Sahu",
        "phone": "9819390445"
      }
    ]
  },
  {
    "name": "RADHAKRISHNA CHAITANY MANDAL PREMIER",
    "address": "Gate No-6, Milind Nagar, Kurla Tarshid Road, Kurla(W), Mumbai-400078",
    "contacts": [
      {
        "name": "Mr Sanatan sahu",
        "phone": "9324349926"
      },
      {
        "name": "Mr Trinath Panda",
        "phone": "9029500346"
      }
    ]
  },
  {
    "name": "JAY AMBE MITRA MANDAL",
    "address": "Raghunath Chawl, Opp. Walton Wadi, Naupada, Kurla, Mumbai-400070",
    "contacts": [
      {
        "name": "Mr. Pradeep Sabat",
        "phone": "8080419255"
      }
    ]
  },
  {
    "name": "KALINGA YUVAK SEVA SANGH",
    "address": "Laxmi Bag, Panth Nagar, Ghatkopar(East), Mumbai-400075",
    "contacts": [
      {
        "name": "Mr Loknath Padhi",
        "phone": "9820101043"
      }
    ]
  },
  {
    "name": "UTKAL VIKASH SAMAJ SANSTHAN",
    "address": "104, Sarvesh Apt. Near Balaji Hospital, Mira Bhayender Road, Mira(East), Thane-401107",
    "contacts": [
      {
        "name": "Mr R.K Sahu",
        "phone": "9820841471"
      }
    ]
  },
  {
    "name": "PASCHIMA ODISHA ODIA PARIVAR",
    "address": "C-803/804, Madhuban, Ketaki pada, Opp.MTNL, Dahisar(East), Mumbai-400068",
    "contacts": [
      {
        "name": "Mr. Deepak Pujari",
        "phone": "9820808918"
      }
    ]
  },
  {
    "name": "JAI JAGANNATH UTTKALA SEVA SAMITI (COLABA)",
    "address": "Room no 520, Ganesh Murty Nagar, part 3, Captain p.p marg, Cuffe parade Colaba, Mumbai 400005",
    "contacts": [
      {
        "role": "President",
        "name": "Achutananda Khatua",
        "phone": "9833598730"
      }
    ]
  },
  {
    "name": "CHAKADOLA SEVA SANGHA, TITWALA.",
    "address": "Jai Jagannath, Yadav Chawl No-2, Balyani road Behind Mata Mandir, Titwala-East, Kalyan, Thane, Maharashtra. 421605",
    "contacts": [
      {
        "name": "Pradipta Sahoo",
        "phone": "9930497591"
      }
    ]
  },
  {
    "name": "SHREE JAGANNATH SEVA MANDAL",
    "address": "Dr. E Moses Road, Mahalaxmi race course, Gate No-8 Worli, Mumbai. 400018",
    "contacts": [
      {
        "role": "Secretary",
        "name": "Madhusudan Behera",
        "phone": "8286463079"
      },
      {
        "role": "Bhajan Contact Person",
        "name": "Ranjeet Khatua",
        "phone": "9930130962"
      }
    ]
  },
  {
    "name": "UTKAL VIKAS SANSTHA",
    "address": "2A/128, Siddhi Vinayak Co. Op. Hsg. Society, Indra Nagar (Jogeshwari) S.R.A. Backside of M.H.B.Colony, Jogeshwari (E), Mumbai - 60. Email- utkalvikassanstha@gmail.com",
    "contacts": [
      {
        "role": "President",
        "name": "Dukhi Shyam Maharana",
        "phone": "9224202473"
      }
    ]
  }
]

export default organizationData;
